import { createContext } from "react";
import { IWithMergeContextProps } from "./IWithMergeContextProps";

export const MergeContext = createContext<IWithMergeContextProps>({
  isMergeSaved: false,
  mergeSelectionMap: null,
  mergedProjectItem: null,
  onMergeChange: null,
  onMergeSave: null,
  onSelectAll: null
});
